import AntSelect, { type SelectProps as AntSelectProps } from "antd/lib/select";
import { type ComponentRef, forwardRef, useState } from "react";

import { ChevronDown } from "@sol/uikit/core/icons/Arrows/ChevronDown";
import { Check01 } from "@sol/uikit/core/icons/General/Check01";
import { Loading } from "@sol/uikit/core/icons/Loading";
import { Magnifier } from "@sol/uikit/core/icons/Magnifier";

export type SelectProps = AntSelectProps;

export const Select = forwardRef<ComponentRef<typeof AntSelect>, SelectProps>(function Select(props, ref) {
    const { suffixIcon, menuItemSelectedIcon, onOpenChange, ...rest } = props;
    const [open, setOpen] = useState(props.open ?? false);
    const isOpen = props.open ?? open;

    const handleOpenChange: SelectProps["onOpenChange"] = visible => {
        setOpen(visible);
        onOpenChange?.(visible);
    };

    const defaultShowSearch = ["multiple", "tags"].includes(props.mode ?? "");

    let defaultSuffixIcon = <ChevronDown variant="antd" className="aspect-square size-full" />;
    if (isOpen && (props.showSearch ?? defaultShowSearch)) {
        defaultSuffixIcon = <Magnifier variant="antd" className="aspect-square size-full" />;
    }

    return (
        <AntSelect
            {...rest}
            ref={ref}
            onOpenChange={handleOpenChange}
            menuItemSelectedIcon={menuItemSelectedIcon ?? <Check01 variant="antd" />}
            suffixIcon={
                rest.loading ? (
                    <Loading variant="antd" className="aspect-square size-full animate-spin duration-1000!" />
                ) : (
                    (suffixIcon ?? defaultSuffixIcon)
                )
            }
        />
    );
});
